import React from 'react';
import type { PapiDeviation } from '@wix/da-papi-types';
import { useDeviationBlockType } from '../../hooks/useDeviationBlockType';
import BlockedSubscribedMiddleContent from './_partials/BlockedSubscribedMiddleContent';
import NeedsSubscriptionMiddleContent from './_partials/NeedsSubscriptionMiddleContent';
import PremiumLockedMiddleContent from './_partials/PremiumLockedMiddleContent';
import WatchersOnlyMiddleContent from './_partials/WatchersOnlyMiddleContent';
import ContentFilterMiddleContent from './_partials/ContentFilterMiddleContent';
import BlockedMiddleContent from './_partials/BlockedMiddleContent';

interface Props {
  deviation: PapiDeviation;
  thumbWidth?: number;
  thumbHeight?: number;
  className?: string;
  isMatureBlock?: boolean;
}

const DeviationThumbMiddleContent: React.FC<React.PropsWithChildren<Props>> = ({
  deviation,
  thumbHeight,
  thumbWidth,
  className,
  children,
  isMatureBlock,
}) => {
  const blockType = useDeviationBlockType(deviation);
  switch (blockType) {
    case 'matureFilter':
      // mature blocks have had their styles updated
      // - other overlays no longer match
      const FeatureSplitComponent = isMatureBlock
        ? ContentFilterMiddleContent
        : BlockedMiddleContent;
      return (
        <FeatureSplitComponent
          deviation={deviation}
          thumbWidth={thumbWidth}
          thumbHeight={thumbHeight}
          className={className}
        />
      );
    case 'premiumFolder':
      return (
        <PremiumLockedMiddleContent
          deviation={deviation}
          thumbWidth={thumbWidth}
          thumbHeight={thumbHeight}
          className={className}
        />
      );
    case 'watchersOnly':
      return (
        <WatchersOnlyMiddleContent
          deviation={deviation}
          thumbWidth={thumbWidth}
          thumbHeight={thumbHeight}
          className={className}
        />
      );
    case 'subsOnly':
      return (
        <NeedsSubscriptionMiddleContent
          deviation={deviation}
          thumbWidth={thumbWidth}
          thumbHeight={thumbHeight}
          className={className}
        />
      );
    case 'subBlocked':
      return (
        <BlockedSubscribedMiddleContent
          thumbWidth={thumbWidth}
          thumbHeight={thumbHeight}
          className={className}
        />
      );
    default:
      return <>{children}</>;
  }
};
DeviationThumbMiddleContent.displayName = 'DeviationThumbMiddleContent';

export default DeviationThumbMiddleContent;
